/**
 * V2-only localStorage persistence for the user's chosen column count in the
 * GDPR PDF viewer. Kept here (not in the shared Redux slice) so V1 is unaffected.
 *
 * Storage is a single integer 1-4. Anything else, missing, or thrown reads fall
 * back to the supplied default — covers private-mode browsers and corrupted values.
 */

const STORAGE_KEY = 'gdprV2.columnSize';

export type ColumnSize = 1 | 2 | 3 | 4;
export const DEFAULT_COLUMN_SIZE: ColumnSize = 2;

const isValidColumnSize = (value: unknown): value is ColumnSize =>
  value === 1 || value === 2 || value === 3 || value === 4;

export const readColumnSizeFromStorage = (): ColumnSize => {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (raw === null) return DEFAULT_COLUMN_SIZE;
    const parsed = Number(raw);
    return isValidColumnSize(parsed) ? parsed : DEFAULT_COLUMN_SIZE;
  } catch {
    return DEFAULT_COLUMN_SIZE;
  }
};

export const writeColumnSizeToStorage = (value: ColumnSize): void => {
  try {
    window.localStorage.setItem(STORAGE_KEY, String(value));
  } catch {
    // Storage might be unavailable (private mode, quota); silently ignore.
  }
};
